"use client";

import { useMemo } from "react";
import { apiToUnit } from "@/component/unit-detail/adapt";
import { useUnits } from "@/hooks/useProjects";
import type { Unit } from "@/types/units";

/** A code → Unit lookup over the real public units (for Compare / Saved by code). */
export function useUnitsMap(): { map: Map<string, Unit>; isLoading: boolean } {
  const { data, isLoading } = useUnits({ page: 1, limit: 60 });
  const map = useMemo(() => {
    const m = new Map<string, Unit>();
    (data?.items ?? []).forEach((u) => m.set(u.code, apiToUnit(u)));
    return m;
  }, [data]);
  return { map, isLoading };
}
